
import React from 'react'
import moment from 'moment'
import TableValueAction from '../../../MuiTable/components/TableValueAction'
import InfoCpa from '../../../Camiones/containers/busquedaCpa/InfoCpa'
import { COLORES } from '../../../../config/colores'

export const COL_TOTAL_SIN_ANALISIS = [
  {
    name: 'anioDescarga',
    label: 'Año de descarga',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'mesDescarga',
    label: 'Mes de descarga',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'pesoNetoTotal',
    label: 'Peso neto',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (peso) => {
        return peso > 0 ? <>{peso} kg.</> : ' - '
      }
    }
  },
  {
    name: 'cantidad',
    label: 'Cantidad',
    options: {
      filter: false,
      sort: true,
      total: true
    }
  }
]

export const TOTAL_SIN_ANALISIS_TO_PRINT = [
  {
    name: 'anioDescarga',
    label: 'Año de descarga',
    width: '120'
  },
  {
    name: 'mesDescarga',
    label: 'Mes de descarga',
    width: '120'
  },
  {
    name: 'cereal',
    label: 'Cereal',
    width: '120'
  },
  {
    name: 'pesoNetoTotal',
    label: 'Peso neto',
    width: '120'
  },
  {
    name: 'cantidad',
    label: 'Cantidad',
    width: '120'
  }
]

export const COL_MERCADERIA_SIN_ANALISIS = [
  {
    name: 'fechaDeDescarga',
    label: 'Fecha de descarga',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect'
    }
  },
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'cerealVariedad',
    label: 'Cereal variedad',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox',
      customBodyRender: (variedad) => {
        return ((variedad.trim() === 'UNDEF') ? '- ' : variedad)
      }
    }
  },
  {
    name: 'cartaDePorte',
    label: 'Carta de porte',
    options: {
      filter: true,
      sort: true,
      setCellProps: () => ({
        style: {
          position: 'sticky',
          left: '0',
          background: COLORES.grey.light,
          zIndex: 100
        }
      }),
      setCellHeaderProps: () => ({
        style: {
          whiteSpace: 'nowrap',
          position: 'sticky',
          left: 0,
          background: 'white',
          zIndex: 101
        }
      }),
      customBodyRender: (numero) => {
        return (
          <>
            {numero
              ? <TableValueAction
                value={numero}
                title=' '
                content={<InfoCpa cpa={numero} />} />
              : null
            }
          </>
        )
      }
    }
  },
  {
    name: 'estadoCalificacion',
    label: 'Estado calificación',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'calificacionCereal',
    label: 'Calificación cereal',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect'
    }
  },
  {
    name: 'pesoNeto',
    label: 'Peso neto',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (peso) => {
        return peso > 0 ? <>{peso} kg.</> : ' - '
      }
    }
  }
]

export const SIN_ANALISIS_TO_PRINT = [
  {
    name: 'fechaDeDescarga',
    label: 'Fecha descarga',
    width: '90'
  },
  {
    name: 'cereal',
    label: 'Cereal',
    width: '80'
  },
  {
    name: 'cerealVariedad',
    label: 'Cereal variedad',
    width: '80'
  },
  {
    name: 'cartaDePorte',
    label: 'Carta de porte',
    width: '80'
  },
  {
    name: 'estadoCalificacion',
    label: 'Estado calificación',
    width: '90'
  },
  {
    name: 'calificacionCereal',
    label: 'Calificación cereal',
    width: '90'
  },
  {
    name: 'pesoNeto',
    label: 'Peso neto',
    width: '80'
  }
]

export const COL_CALIDAD_EMBARQUE = [
  {
    name: 'buque',
    label: 'Buque',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect'
    }
  },
  {
    name: 'fechaDeMuestra',
    label: 'Fecha de muestra',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect',
      customBodyRender: (fecha) => fecha ? <>{moment(fecha).format('DD-MM-YYYY')}</> : null
    }
  },
  {
    name: 'turnoDeTrabajo',
    label: 'Turno de trabajo',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect'
    }
  },
  {
    name: 'razonSocial',
    label: 'Exportador',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect'
    }
  },
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'humedad',
    label: 'Humedad',
    options: {
      filter: false,
      sort: true
    }
  },
  {
    name: 'gradoCacba',
    label: 'Grado CACBC',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'ph',
    label: 'PH',
    options: {
      filter: false,
      sort: true
    }
  },
  {
    name: 'pesoTotal',
    label: 'Peso total',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (peso) => {
        return peso > 0 ? <>{peso} kg.</> : ' - '
      }
    }
  }
]

export const CALIDAD_EMBARQUE_TO_PRINT = [
  {
    name: 'buque',
    label: 'Buque',
    width: '80'
  },
  {
    name: 'fechaDeMuestra',
    label: 'Fecha de muestra',
    width: '80'
  },
  {
    name: 'turnoDeTrabajo',
    label: 'Turno de trabajo',
    width: '100'
  },
  {
    name: 'razonSocial',
    label: 'Exportador',
    width: '120'
  },
  {
    name: 'cereal',
    label: 'Cereal',
    width: '80'
  },
  {
    name: 'humedad',
    label: 'Humedad',
    width: '80'
  },
  {
    name: 'gradoCacba',
    label: 'Grado CACBC',
    width: '80'
  },
  {
    name: 'ph',
    label: 'PH',
    width: '80'
  },
  {
    name: 'pesoTotal',
    label: 'Peso total',
    width: '80'
  }
]

export const COL_CALIDAD_EMBARQUE_TOTAL = [
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'gradoCacba',
    label: 'Grado CACBC',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'humedadPromedio',
    label: 'Humedad promedio',
    options: {
      filter: false,
      sort: true
    }
  },
  {
    name: 'phPromedio',
    label: 'PH promedio',
    options: {
      filter: false,
      sort: true
    }
  },
  {
    name: 'pesoNetoTotal',
    label: 'Peso neto total',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (peso) => {
        return peso > 0 ? <>{peso} kg.</> : ' - '
      }
    }
  }
]

export const CALIDAD_EMBARQUE_TOTAL_TO_PRINT = [
  {
    name: 'cereal',
    label: 'Cereal',
    width: '90'
  },
  {
    name: 'gradoCacba',
    label: 'Grado CACBC',
    width: '90'
  },
  {
    name: 'humedadPromedio',
    label: 'Humedad promedio',
    width: '100'
  },
  {
    name: 'phPromedio',
    label: 'PH promedio',
    width: '90'
  },
  {
    name: 'pesoNetoTotal',
    label: 'Peso neto total',
    width: '90'
  }
]

export const COL_CONTROL_DE_GRADO = [
  {
    name: 'fechaDeDescarga',
    label: 'Fecha de descarga',
    options: {
      filter: false,
      sort: true
    }
  },
  {
    name: 'cartaDePorte',
    label: 'Carta de porte',
    options: {
      filter: true,
      sort: true,
      setCellProps: () => ({
        style: {
          position: 'sticky',
          left: '0',
          background: COLORES.grey.light,
          zIndex: 100
        }
      }),
      setCellHeaderProps: () => ({
        style: {
          whiteSpace: 'nowrap',
          position: 'sticky',
          left: 0,
          background: 'white',
          zIndex: 101
        }
      }),
      customBodyRender: (numero) => {
        return (
          <>
            {numero
              ? <TableValueAction
                value={numero}
                title=' '
                content={<InfoCpa cpa={numero} />} />
              : null
            }
          </>
        )
      }
    }
  },
  {
    name: 'exportador',
    label: 'Exportador',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect'
    }
  },
  {
    name: 'cargador',
    label: 'Cargador',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect'
    }
  },
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'gradoCalculado',
    label: 'Grado calculado',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'gradoCamara',
    label: 'Grado CACBC',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  }
]

export const CONTROL_DE_GRADO_TO_PRINT = [
  {
    name: 'fechaDeDescarga',
    label: 'Fecha de descarga',
    width: 70
  },
  {
    name: 'cartaDePorte',
    label: 'Carta de porte',
    width: 70
  },
  {
    name: 'exportador',
    label: 'Exportador',
    width: 120
  },
  {
    name: 'cargador',
    label: 'Cargador',
    width: 120
  },
  {
    name: 'cereal',
    label: 'Cereal',
    width: 70
  },
  {
    name: 'gradoCalculado',
    label: 'Grado calculado',
    width: 70
  },
  {
    name: 'gradoCamara',
    label: 'Grado CACBC',
    width: 70
  }
]

export const COL_CONTROL_DE_REBAJAS = [
  {
    name: 'fechaDeDescarga',
    label: 'Fecha de descarga',
    options: {
      filter: false,
      sort: true
    }
  },
  {
    name: 'cartaDePorte',
    label: 'Carta de porte',
    options: {
      filter: true,
      sort: true,
      setCellProps: () => ({
        style: {
          position: 'sticky',
          left: '0',
          background: COLORES.grey.light,
          zIndex: 100
        }
      }),
      setCellHeaderProps: () => ({
        style: {
          whiteSpace: 'nowrap',
          position: 'sticky',
          left: 0,
          background: 'white',
          zIndex: 101
        }
      }),
      customBodyRender: (numero) => {
        return (
          <>
            {numero
              ? <TableValueAction
                value={numero}
                title=' '
                content={<InfoCpa cpa={numero} />} />
              : null
            }
          </>
        )
      }
    }
  },
  {
    name: 'exportador',
    label: 'Exportador',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect'
    }
  },
  {
    name: 'cargador',
    label: 'Cargador',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect'
    }
  },
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'gradoCalculado',
    label: 'Grado calculado',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'gradoCamara',
    label: 'Grado CACBC',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'rebajaNoIncidenteNivel0',
    label: 'Rebaja calculada',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'rebajaCamara',
    label: 'Rebaja CACBC',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  }
]

export const CONTROL_DE_REBAJAS_TO_PRINT = [
  {
    name: 'fechaDeDescarga',
    label: 'Fecha de descarga',
    width: 70
  },
  {
    name: 'cartaDePorte',
    label: 'Carta de porte',
    width: 70
  },
  {
    name: 'exportador',
    label: 'Exportador',
    width: 140
  },
  {
    name: 'cargador',
    label: 'Cargador',
    width: 140
  },
  {
    name: 'cereal',
    label: 'Cereal',
    width: 70
  },
  {
    name: 'gradoCalculado',
    label: 'Grado calculado',
    width: 70
  },
  {
    name: 'gradoCamara',
    label: 'Grado CACBC',
    width: 70
  },
  {
    name: 'rebajaNoIncidenteNivel0',
    label: 'Rebaja calculada',
    width: 70
  },
  {
    name: 'rebajaCamara',
    label: 'Rebaja CACBC',
    width: 70
  }
]

export const COL_SOLICITUD_ANALISIS = [
  {
    name: 'fechaDeDescarga',
    label: 'Fecha de descarga',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'pesoNetoTotal',
    label: 'Peso neto',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (peso) => {
        return peso > 0 ? <>{peso} kg.</> : ' - '
      }
    }
  }
]

export const SOLICITUD_ANALISIS_TO_PRINT = [
  {
    name: 'fechaDeDescarga',
    label: 'Fecha de descarga',
    width: '120'
  },
  {
    name: 'cereal',
    label: 'Cereal',
    width: '120'
  },
  {
    name: 'pesoNetoTotal',
    label: 'Peso neto',
    width: '120'
  }
]
